import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AddLoginHistory, EventHistoryRecords, EventTypes, UpdateEventHistoryTableParam } from "src/app/_models/EventDto";
import { EventHistoryActionTypes } from "src/app/constants/StoreConstants";

export const GetAllEventTypes = createAction(
  EventHistoryActionTypes.GetAllEventTypes
);

export const GetAllEventTypesSuccess = createAction(
  EventHistoryActionTypes.GetAllEventTypesSuccess,
  props<{result: EventTypes[]}>()
);

export const GetAllEventTypesError = createAction(
  EventHistoryActionTypes.GetAllEventTypesError,
  props<{error: HttpErrorResponse}>()
);
export const GetEventHistoryRecords = createAction(
  EventHistoryActionTypes.GetEventHistoryRecords,
  props<{userId: number, pageNumber: number, isInitialLoad: boolean}>()
);

export const GetEventHistoryRecordsSuccess = createAction(
  EventHistoryActionTypes.GetEventHistoryRecordsSuccess,
  props<{result: EventHistoryRecords[]}>()
);

export const GetEventHistoryRecordsError = createAction(
  EventHistoryActionTypes.GetEventHistoryRecordsError,
  props<{error: HttpErrorResponse}>()
);

export const SaveLoginHistory = createAction(
  EventHistoryActionTypes.SaveLoginHistory,
  props<{loginHistory: AddLoginHistory}>()
);

export const SaveLoginHistorySuccess = createAction(
  EventHistoryActionTypes.SaveLoginHistorySuccess,
  props<{result: boolean}>()
);

export const SaveLoginHistoryError = createAction(
  EventHistoryActionTypes.SaveLoginHistoryError,
  props<{error: HttpErrorResponse}>()
);

export const GetCurrentPageNumber = createAction(
  EventHistoryActionTypes.GetCurrentPageNumber,
  props<{pageIndex: number}>()
);

export const GetCurrentPageNumberSuccess = createAction(
  EventHistoryActionTypes.GetCurrentPageNumberSuccess,
  props<{result: number}>()
);

export const GetCurrentPageNumberError = createAction(
  EventHistoryActionTypes.GetCurrentPageNumberError,
  props<{error: HttpErrorResponse}>()
);

export const UpdateEventHistoriesTable = createAction(
  EventHistoryActionTypes.UpdateEventHistoriesTable,
  props<{param: UpdateEventHistoryTableParam, userId: number}>()
);

export const UpdateEventHistoriesTableSuccess = createAction(
  EventHistoryActionTypes.UpdateEventHistoriesTableSuccess,
  props<{result: boolean}>()
);

export const UpdateEventHistoriesTableError = createAction(
  EventHistoryActionTypes.UpdateEventHistoriesTableError,
  props<{error: HttpErrorResponse}>()
);

export const GetEventHistoryRecordLength = createAction(
  EventHistoryActionTypes.GetEventHistoryRecordLength
);

export const GetEventHistoryRecordLengthSuccess = createAction(
  EventHistoryActionTypes.GetEventHistoryRecordLengthSuccess,
  props<{result: number}>()
);

export const GetEventHistoryRecordLengthError = createAction(
  EventHistoryActionTypes.GetEventHistoryRecordLengthError,
  props<{error: HttpErrorResponse}>()
);